import en from './locales/en';
import sv from './locales/sv';

export type Locale = 'sv' | 'en';

export const LOCALE_STORAGE_KEY = 'locale';
export const DEFAULT_LOCALE: Locale = 'sv';

export const messages: Record<Locale, Record<string, string>> = {
  sv,
  en,
};
